
import { Vue, Component, Prop } from "vue-property-decorator";
import { AmCard, AmCardBody } from "@afe/amui/src/components/Card";
import { AmTypography } from "@afe/amui/src/components/Typography";
import { AmButton } from "@afe/amui/src/components/Button";
import { AmSpacing } from "@afe/amui/src/components/Spacing";
import {
  FormBack,
  FormSubmit,
  Preloader,
  FormModal,
  FormError
} from "../components";
import { api } from "@/forms/api";

@Component({
  components: {
    AmCard,
    AmTypography,
    AmCardBody,
    AmSpacing,
    FormBack,
    AmButton,
    Preloader,
    FormSubmit,
    FormModal,
    FormError
  }
})
export default class extends Vue {
  @Prop(Object) readonly config!: any;
  @Prop(Object) readonly formData!: any;
  loading = false;
  showModal = false;
  isError = false;

  async onSendVerify() {
    const { email } = this.formData;
    this.loading = true;
    this.isError = false;

    try {
      await api.uas.resendVerifyEmail({ email });
      this.showModal = true;
    } catch (e) {
      this.isError = true;
    }

    this.loading = false;
  }
}
